/**
 * cerf
 */

import Component from '../../js/lib/component';
import 'lightgallery';

const classList = {
  parent: '.cerfs',
  root: '.js-cerf',
  image: '.js-cerf-src'
};

export default class Cerf extends Component {
  init() {
    this.$.root.lightGallery({
      selector: classList.image,
      selectWithin: classList.parent,
      download: false,
      counter: false,
      startClass: 'lg-fade',
      getCaptionFromTitleOrAlt: false
    });
  }
}

Component.mount(Cerf, {
  name: 'Cerf',
  classList,
  state: {}
});
